
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import GlobalSnackbarItem from '@/components/GlobalSnackbar/GlobalSnackbarItem.vue';

export default Vue.extend({
	components: {
		GlobalSnackbarItem,
	},
	computed: {
		...mapState([
			'snackbars',
		]),
	},
	methods: {
		...mapActions([
			'dismissSnackbar',
		]),
	},
});
